import { Injectable } from '@angular/core';
import { Currency } from '../currency';
import { PaymentReceived } from '../payment-received';
import { PaymentType } from '../payment-type';

@Injectable({
  providedIn: 'root'
})
export class PaymentReceivedService {

  currencies: Currency[] = [];
  paymentTypes: PaymentType[] = [];
  selectedPayemnt!: PaymentReceived;

  payments: PaymentReceived[] = [];

  constructor() { }

  public duplicatePayment(payment: PaymentReceived){
    return new PaymentReceived(
      payment.comment,
      payment.date, 
      payment.amount,
      payment.paymentType,
      payment.invoiceNumber,
      payment.currency,
      payment.isFinancialRecord,
      payment.created,
      payment.createdBy,
      payment.lastModified,
      payment.lastModifiedBy,
      payment.id,
      payment.sortOrder,
      payment.amountInEuro,
      payment.hidden
  );
  }
}
